import { render, staticRenderFns } from "./HeaderPreviousEditions.vue?vue&type=template&id=283eec98&"
import script from "./HeaderPreviousEditions.vue?vue&type=script&lang=js&"
export * from "./HeaderPreviousEditions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports